import React from "react";
import insights from "../content/insights.json";

const InsightsPage = () => {
  return (
    <main data-testid="insights-page" className="bg-ivory">
      <section className="pt-40 md:pt-48 pb-20 max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-xs tracking-[0.32em] uppercase font-medium text-muted_gold">
            {insights.overline}
          </p>
          <h1 className="mt-6 font-heading font-normal text-charcoal text-5xl sm:text-6xl md:text-7xl tracking-tight">
            {insights.heading}
          </h1>
          <div className="mt-8 mx-auto w-12 h-px bg-muted_gold" />
          <p className="mt-10 text-charcoal-soft text-lg leading-relaxed">
            {insights.intro}
          </p>
        </div>
      </section>

      <section className="pb-40 max-w-6xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {insights.articles.map((article, i) => (
            <article
              key={i}
              data-testid={`insight-card-${i}`}
              className="museum-plaque border border-charcoal/10 bg-ivory p-10 flex flex-col justify-between min-h-[320px]"
            >
              <div>
                <p className="text-xs tracking-[0.32em] uppercase font-medium text-muted_gold">
                  {article.overline}
                </p>
                <h3 className="mt-5 font-heading font-normal text-2xl md:text-3xl text-charcoal leading-snug">
                  {article.title}
                </h3>
                <p className="mt-5 text-charcoal-soft text-base leading-relaxed">
                  {article.excerpt}
                </p>
              </div>
              <span className="mt-8 text-xs tracking-[0.28em] uppercase font-medium text-charcoal-soft">
                {article.status}
              </span>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
};

export default InsightsPage;
